import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { CardMenu } from '@/components/ui/card';
    import { columns } from '@/tables/columns/user-companies';
    import { Head } from '@inertiajs/vue3';
    import { ref } from 'vue';
    import { useQuery } from '@tanstack/vue-query';
    import { useUrlSearch } from '@/composables/useUrlSearch';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import DataTable from '@/components/datatable/DataTable.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { BreadcrumbItem, NavItem } from '@/types';
    import type { ColumnFiltersState, SortingState } from '@tanstack/vue-table';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UserCompanies',
  setup(__props) {

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.settings',
        },
        {
            title: 'menu.employees',
            href: route('v2.user-companies.index'),
        },
    ];

    const navItems: NavItem[] = [
        {
            title: 'companies.header_user_companies',
            href: route('v2.user-companies.index'),
            permissionLevel: Permission.COMPANIES_VIEW,
        },
        {
            title: 'user-groups.header_users_groups',
            href: route('v2.user-groups.index'),
            permissionLevel: Permission.COMPANIES_VIEW,
        },
    ];
    const { extractAndCleanSearch } = useUrlSearch();
    const initialSearch = extractAndCleanSearch();

    const dataTableRef = ref<any>(null);

    const { isPending, data } = useQuery({
        queryKey: [QueryKey.USER_COMPANIES],
        queryFn: getUserCompanies,
    });

    async function getUserCompanies() {
        const { data } = await axios.get(route('v2.user-companies.table'), {
            params: {
                search: initialSearch || undefined,
            },
        });
        return data.data;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('profile.profile_settings')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, { breadcrumbs: breadcrumbs }, {
      default: _withCtx(() => [
        _createVNode(PageCard, null, {
          default: _withCtx(() => [
            _createVNode(DataTable, {
              "table-key": _unref(QueryKey).USER_COMPANIES,
              ref_key: "dataTableRef",
              ref: dataTableRef,
              columns: _unref(columns),
              data: _unref(data),
              loading: _unref(isPending),
              "auto-url-search": true,
              "default-column-visibility": {
                    id: false,
                }
            }, {
              title: _withCtx(() => [
                _createVNode(_unref(CardMenu), { items: navItems })
              ]),
              _: 1
            }, 8, ["table-key", "columns", "data", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})